import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './utils/store';

export interface AppState {
    showSidebar: boolean;
}

const initialState: AppState = {
    showSidebar: false,
};

export const appSlice = createSlice({
    name: 'app',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        setShowSidebar: (state, action: PayloadAction<boolean>) => {
            state.showSidebar = action.payload;
        },
    },
});

export const { setShowSidebar } = appSlice.actions;
export const actions = appSlice.actions;

export const selectShowSidebar = (state: RootState) => state.app.showSidebar;

export default appSlice.reducer;
